import Vue from 'vue'
import Vuex from 'vuex'
import API from '../services/api'
import Validation from '../services/validation';
import * as MUTATIONS from './mutation-types';
import * as ACTIONS from './action-types';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        ERRORS: {},
        BUSY: true,
        VEHICLE_TYPE: 'car',
        FUEL_TYPE: 'petrol',
        DISPLAY_RESULT: false,
        FUEL_PRICE_ELECTRIC : 0,
        FUEL_PRICE_PETROL: 0,
        FUEL_PRICE_DIESEL: 0,
        MILEAGE: 7500,
        GENERIC_VEHICLES: {},
        EV_CARS:[],
        EV_VANS:[],
        LTG_CONVERSION: 4.546,
        SELECTED_VEHICLE:{
            id: 0
        },
    },
    mutations: {
        [MUTATIONS.BUSY]: (state, applicationState) => state.BUSY = applicationState,
        [MUTATIONS.VEHICLE_TYPE]: (state, type) => state.VEHICLE_TYPE = type,
        [MUTATIONS.FUEL_TYPE]: (state, type) => state.FUEL_TYPE = type,
        [MUTATIONS.DISPLAY_RESULT]: (state, display) => state.DISPLAY_RESULT = display,
        [MUTATIONS.FUEL_PRICE_ELECTRIC]: (state, price) => state.FUEL_PRICE_ELECTRIC = price,
        [MUTATIONS.FUEL_PRICE_DIESEL]: (state, price) => state.FUEL_PRICE_DIESEL = price,
        [MUTATIONS.FUEL_PRICE_PETROL]: (state, price) => state.FUEL_PRICE_PETROL = price,
        [MUTATIONS.MILEAGE]: (state, mileage) => state.MILEAGE = mileage,
        [MUTATIONS.GENERIC_VEHICLES]: (state, vehicles) => state.GENERIC_VEHICLES = vehicles,
        [MUTATIONS.EV_CARS]: (state, list) => state.EV_CARS = list,
        [MUTATIONS.EV_VANS]: (state, list) => state.EV_VANS = list,
        [MUTATIONS.SELECTED_VEHICLE]: (state, vehicle) => state.SELECTED_VEHICLE = vehicle,
        [MUTATIONS.ERROR]: (state, errorObject) => state.ERRORS = {...state.ERRORS, [errorObject.name]: errorObject.message},
        [MUTATIONS.REMOVE_ERROR]: (state, property) => Vue.delete(state.ERRORS, property),
    },
    actions: {
        [ACTIONS.LOAD_DATA]: (context) => {
            API.getData(
                (result) => {
                    if (result.status.OK) {
                        context.commit(MUTATIONS.GENERIC_VEHICLES, result.data.genericVehicles);
                        context.commit(MUTATIONS.EV_CARS, result.data.vehicles.cars);
                        context.commit(MUTATIONS.EV_VANS, result.data.vehicles.vans);
                        context.dispatch(ACTIONS.FUEL_PRICES, result.data.fuelPrices);
                        context.commit(MUTATIONS.BUSY, false);
                    }
                },
                (error) => {
                    context.commit(MUTATIONS.ERROR, error);
                }
            );
        },
        [ACTIONS.FUEL_PRICES]: (context, prices) => {
            context.commit(MUTATIONS.FUEL_PRICE_ELECTRIC, prices.electric);
            context.commit(MUTATIONS.FUEL_PRICE_PETROL, prices.petrol);
            context.commit(MUTATIONS.FUEL_PRICE_DIESEL, prices.diesel);
        },
        [ACTIONS.MILEAGE_VALID]: (context, mileage) => {
            mileage = parseFloat(mileage);
            Validation.validateMileage(mileage,
                function (errorObject) {
                    context.commit(MUTATIONS.ERROR, errorObject);
                },
                function (fieldName) {
                    context.commit(MUTATIONS.REMOVE_ERROR, fieldName);
                    context.commit(MUTATIONS.MILEAGE, mileage);
                }
            );
        },
        [ACTIONS.ELECTRIC_VALID]: (context, price) =>{
            price = parseFloat(price);
            Validation.validateElectric(price,
                function (errorObject) {
                    context.commit(MUTATIONS.ERROR, errorObject);
                },
                function (fieldName) {
                    context.commit(MUTATIONS.REMOVE_ERROR, fieldName);
                    context.commit(MUTATIONS.FUEL_PRICE_ELECTRIC, price);
                }
            );
        },
        [ACTIONS.PETROL_VALID]: (context, price) => {
            price = parseFloat(price);
            Validation.validatePetrol(price,
                function (errorObject) {
                    context.commit(MUTATIONS.ERROR, errorObject);
                },
                function (fieldName) {
                    context.commit(MUTATIONS.REMOVE_ERROR, fieldName);
                    context.commit(MUTATIONS.FUEL_PRICE_PETROL, price);
                }
            );
        },
        [ACTIONS.DIESEL_VALID]: (context, price) => {
            price = parseFloat(price);
            Validation.validateDiesel(price,
                function (errorObject) {
                    context.commit(MUTATIONS.ERROR, errorObject);
                },
                function (fieldName) {
                    context.commit(MUTATIONS.REMOVE_ERROR, fieldName);
                    context.commit(MUTATIONS.FUEL_PRICE_DIESEL, price);
                }
            );
        }
    },
    getters: {
        vehicles: (state) => {
            return (state.VEHICLE_TYPE === "car") ? state.EV_CARS : state.EV_VANS;
        }
    }
})
